export function selectMyCircles(allCircles = [], userId) {
  if (!Array.isArray(allCircles)) return [];
  const isMine = (c) =>
    c?.is_member === true ||
    c?.joined === true ||
    !!c?.membership_id ||
    (userId &&
      Array.isArray(c?.members) &&
      c.members.some(m => m?.id === userId || m?.user_id === userId));
  return allCircles.filter(isMine);
}